import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-259f4cd0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "writeoffs-list" }
const _hoisted_2 = { class: "flex itemscenter justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_5 = { class: "mt-6 bg-white px-6 py-4 border" }
const _hoisted_6 = { class: "grid grid-cols-3 mb-3" }
const _hoisted_7 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-3 mt-2" }
const _hoisted_8 = { class: "text-sm text-gray-400" }
const _hoisted_9 = {
  key: 0,
  class: "grid grid-cols-1 lg:grid-cols-3 gap-3 mt-3"
}
const _hoisted_10 = { class: "bg-white border px-6 py-4 mt-3" }
const _hoisted_11 = { class: "font-semibold mb-2" }
const _hoisted_12 = {
  key: 0,
  class: "writeoffs-list__items mt-3"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_15 = {
  key: 1,
  class: "text-sm text-gray-400"
}
const _hoisted_16 = { class: "bg-white border px-6 py-4 mt-3" }
const _hoisted_17 = { class: "font-semibold mb-2" }
const _hoisted_18 = { class: "writeoffs-list__form" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_21 = {
  key: 0,
  class: "bg-white border px-6 py-4 mt-3"
}
const _hoisted_22 = { class: "flex justify-between items-center mb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold" }, "Укажите габариты упакованного груза (в сантиметрах)", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_25 = {
  key: 0,
  class: "text-sm text-center text-gray-400"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_27 = {
  key: 1,
  class: "bg-white border px-6 py-4 mt-3"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold mb-2" }, "Загрузить фотографии упаковки", -1))
const _hoisted_29 = { class: "flex items-center justify-end mt-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_file_reader = _resolveComponent("file-reader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Списание" }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_button, {
          class: "second small text",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/tmc/write-offs')))
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Назад ")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_checkbox, {
          label: "По накладной",
          value: _ctx.state.is_invoice_number,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.is_invoice_number) = $event)),
          disabled: _ctx.state.is_loading,
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onWarehouseChange(1)))
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_checkbox, {
          label: "Складской расход",
          value: _ctx.state.is_warehouse_consumption,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.is_warehouse_consumption) = $event)),
          disabled: _ctx.state.is_loading,
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onWarehouseChange(2)))
        }, null, 8, ["value", "disabled"]),
        _createVNode(_component_checkbox, {
          label: "Проекты",
          value: _ctx.state.is_project,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.is_project) = $event)),
          disabled: _ctx.state.is_loading,
          onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onWarehouseChange(3)))
        }, null, 8, ["value", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_the_select, {
          class: "lg:mt-2",
          placeholder: "Склад",
          disabled: _ctx.state.is_loading,
          "is-invalid": _ctx.state_form$.warehouse_id.$error,
          "validation-errors": _ctx.state_form$.warehouse_id.$errors,
          loading: _ctx.data_state.warehouses.is_loading,
          failed: _ctx.data_state.warehouses.is_failed,
          "error-text": "При получении списка складов произошла ошибка",
          options: _ctx.data_state.warehouses.list,
          value: _ctx.state.warehouse_id,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.warehouse_id) = $event)),
          "search-by": "city",
          onRefresh: _ctx.loadWarehouses
        }, {
          "selected-option": _withCtx(({ option }) => [
            _createTextVNode(" Склад " + _toDisplayString(option.city), 1)
          ]),
          option: _withCtx(({ option }) => [
            _createElementVNode("div", null, [
              _createElementVNode("p", null, "Склад " + _toDisplayString(option.city), 1),
              _createElementVNode("p", _hoisted_8, _toDisplayString(option.full_address), 1)
            ])
          ]),
          _: 1
        }, 8, ["disabled", "is-invalid", "validation-errors", "loading", "failed", "options", "value", "onRefresh"]),
        (!_ctx.state.is_warehouse_consumption)
          ? (_openBlock(), _createBlock(_component_the_input, {
              key: 0,
              placeholder: "Номер накладной",
              "is-invalid": _ctx.state_form$.invoice_number.$error,
              "validation-errors": _ctx.state_form$.invoice_number.$errors,
              value: _ctx.state.invoice_number,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.invoice_number) = $event)),
              disabled: _ctx.state.is_loading
            }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.state.is_warehouse_consumption)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_checkbox, {
              label: "Мягкая упаковка",
              value: _ctx.state.is_soft_package,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.is_soft_package) = $event)),
              disabled: _ctx.state.is_loading || _ctx.state.is_grid || _ctx.state.is_pallet,
              "is-invalid": _ctx.state_form$.is_soft_package.$error
            }, null, 8, ["value", "disabled", "is-invalid"]),
            _createVNode(_component_checkbox, {
              label: "Обрешётка",
              value: _ctx.state.is_grid,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.is_grid) = $event)),
              disabled: _ctx.state.is_loading || _ctx.state.is_soft_package || _ctx.state.is_pallet,
              "is-invalid": _ctx.state_form$.is_grid.$error
            }, null, 8, ["value", "disabled", "is-invalid"]),
            _createVNode(_component_checkbox, {
              label: "Паллетирование",
              value: _ctx.state.is_pallet,
              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.is_pallet) = $event)),
              disabled: _ctx.state.is_loading || _ctx.state.is_grid || _ctx.state.is_soft_package,
              "is-invalid": _ctx.state_form$.is_pallet.$error
            }, null, 8, ["value", "disabled", "is-invalid"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("p", _hoisted_11, "Товары к списанию (" + _toDisplayString(_ctx.state.items.length) + ")", 1),
      (_ctx.state.items.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.items, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "items__item",
                key: `item-${i}`
              }, [
                _createVNode(_component_the_input, {
                  placeholder: "ТМЦ",
                  value: item.tmc_name,
                  disabled: ""
                }, null, 8, ["value"]),
                _createVNode(_component_the_input, {
                  placeholder: "Кол-во",
                  value: item.amount,
                  disabled: ""
                }, null, 8, ["value"]),
                _createVNode(_component_the_button, {
                  class: "yellow small text lg:mt-2 lg:py-3",
                  disabled: _ctx.state.is_loading,
                  onClick: ($event: any) => (_ctx.startUpdateItem(i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]),
                _createVNode(_component_the_button, {
                  class: "red small text lg:mt-2 lg:py-3",
                  disabled: _ctx.state.is_loading,
                  onClick: ($event: any) => (_ctx.removeItem(i))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_15, " Для списания необходимо добавить хотя бы 1 товар "))
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("p", _hoisted_17, [
        (_ctx.state.is_update)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode("Редактирование товара к списанию")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode("Добавление товара к списанию")
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_the_select, {
          class: "lg:mt-2",
          placeholder: "Выберите ТМЦ",
          options: _ctx.data_state.tmc.list,
          loading: _ctx.data_state.tmc.is_loading,
          failed: _ctx.data_state.tmc.is_failed,
          "is-invalid": _ctx.item_form$.tmc_id.$error,
          "validation-errors": _ctx.item_form$.tmc_id.$errors,
          "error-text": "При получении списка ТМЦ произошла ошибка",
          value: _ctx.item_state.tmc_id,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.item_state.tmc_id) = $event)),
          disabled: _ctx.state.is_loading,
          "infinite-scroll": "",
          "search-by": "name",
          onRefresh: _cache[13] || (_cache[13] = ($event: any) => (_ctx.loadTMC(_ctx.data_state.tmc.pagination.current_page))),
          onLoadmore: _cache[14] || (_cache[14] = ($event: any) => (_ctx.loadMoreTMC(_ctx.data_state.tmc.pagination.current_page + 1))),
          onSearch: _ctx.searchTMC,
          onOptionBySearch: _ctx.unshiftFindedTMC
        }, {
          "selected-option": _withCtx(({ option }) => [
            _createTextVNode(_toDisplayString(`${option.name} (${option.unitName})`), 1)
          ]),
          option: _withCtx(({ option }) => [
            _createTextVNode(_toDisplayString(`${option.name} (${option.unitName})`), 1)
          ]),
          _: 1
        }, 8, ["options", "loading", "failed", "is-invalid", "validation-errors", "value", "disabled", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_input, {
          placeholder: "Кол-во",
          "is-invalid": _ctx.item_form$.amount.$error,
          "validation-errors": _ctx.item_form$.amount.$errors,
          value: _ctx.item_state.amount,
          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.item_state.amount) = $event)),
          disabled: _ctx.state.is_loading
        }, null, 8, ["is-invalid", "validation-errors", "value", "disabled"]),
        (_ctx.state.is_update)
          ? (_openBlock(), _createBlock(_component_the_button, {
              key: 0,
              class: "primary small text lg:mt-2 lg:py-3",
              disabled: _ctx.state.is_loading,
              onClick: _ctx.updateItem
            }, {
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
          : (_openBlock(), _createBlock(_component_the_button, {
              key: 1,
              class: "primary small text lg:mt-2 lg:py-3",
              disabled: _ctx.state.is_loading,
              onClick: _ctx.submitItem
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            }, 8, ["disabled", "onClick"]))
      ])
    ]),
    (_ctx.isNeedPlaces)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createVNode(_component_the_button, {
              class: "primary small text lg:py-3",
              disabled: _ctx.state.is_loading || !_ctx.state.items.length,
              onClick: _ctx.addWriteOffPlace
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["disabled", "onClick"])
          ]),
          (_ctx.state.writeOffPlaces.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Места к заполнению появятся автоматически после добавления товара к списанию "))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.writeOffPlaces, (place, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["writeoffs-list__place", { 'mt-2': i !== 0 }]),
              key: `WriteoffPlace-${i}`
            }, [
              _createElementVNode("span", null, "Место №" + _toDisplayString(i + 1), 1),
              _createVNode(_component_the_input, {
                disabled: _ctx.state.is_loading,
                value: place.length,
                "onUpdate:value": ($event: any) => ((place.length) = $event),
                placeholder: "Длина"
              }, null, 8, ["disabled", "value", "onUpdate:value"]),
              _createVNode(_component_the_input, {
                disabled: _ctx.state.is_loading,
                value: place.width,
                "onUpdate:value": ($event: any) => ((place.width) = $event),
                placeholder: "Ширина"
              }, null, 8, ["disabled", "value", "onUpdate:value"]),
              _createVNode(_component_the_input, {
                disabled: _ctx.state.is_loading,
                value: place.height,
                "onUpdate:value": ($event: any) => ((place.height) = $event),
                placeholder: "Высота"
              }, null, 8, ["disabled", "value", "onUpdate:value"]),
              _createVNode(_component_the_button, {
                class: "red small text lg:mt-2 lg:py-3",
                disabled: _ctx.state.is_loading,
                onClick: ($event: any) => (_ctx.removeWriteOffPlace(i))
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.isFiles)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _hoisted_28,
          _createVNode(_component_file_reader, {
            placeholder: "Выберите файл",
            multiple: "",
            value: _ctx.state.packageFiles,
            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.packageFiles) = $event)),
            "is-invalid": _ctx.state_form$.packageFiles.$error,
            "validation-errors": _ctx.state_form$.packageFiles.$errors
          }, null, 8, ["value", "is-invalid", "validation-errors"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_29, [
      _createVNode(_component_the_button, {
        class: "primary small",
        loading: _ctx.state.is_loading,
        disabled: _ctx.state.is_loading,
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [
          _hoisted_30,
          _createTextVNode(" Завершить ")
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"])
    ])
  ]))
}